import Agenda from "@/pages/Agenda";
import Assistentes from "@/pages/Assistentes";
import AssistenteNovo from "@/pages/AssistenteNovo";
import AssistenteEditar from "@/pages/AssistenteEditar";
import Campaigns from "@/pages/Campaigns";
import Chat from "@/pages/Chat";
import Contacts from "@/pages/Contacts";
import ImportarContatos from "@/pages/ImportarContatos";
import Crm from "@/pages/Crm";
import Dashboard from "@/pages/Dashboard";
import Settings from "@/pages/Settings";
import AccessContacts from "@/pages/AccessContacts";
import Agency from "@/pages/Agency";
import Debug from "@/pages/Debug";
import TestError from "@/pages/TestError";
import * as Icons from "../components/ui/shared/Icons";
import type { PermissionArea } from "@/hooks/usePermissions";
import { ConnectionGuard } from "@/components/ui/shared/layout/ConnectionGuard";

export interface NavigationItem {
  icon: React.ReactNode;
  title: string;
  path: string;
  permission?: PermissionArea;
}

export interface RouteConfig {
  path: string;
  element: React.ReactElement;
  permission?: PermissionArea;
  title?: string;
}

export const LeftNavigationData: NavigationItem[] = [
  {
    icon: <Icons.dashboard className="w-[12px] h-[12px]" />,
    title: "Dashboard",
    path: "/",
    permission: "dashboard",
  },
  {
    icon: <Icons.contact className="w-[17px] h-[17px]" />,
    title: "Contatos",
    path: "/contacts",
    permission: "contatos",
  },
  {
    icon: <Icons.chat className="w-[14px] h-[14px]" />,
    title: "Chat",
    path: "/chat",
    permission: "chat",
  },
  {
    icon: <Icons.dashboard className="w-[12px] h-[12px]" />,
    title: "CRM",
    path: "/crm",
    permission: "crm",
  },
  {
    icon: <Icons.agenda className="w-[16px] h-[16px]" />,
    title: "Agenda",
    path: "/agenda",
    permission: "agenda",
  },
  {
    icon: <Icons.assistance className="w-[17px] h-[17px]" />,
    title: "Assistentes",
    path: "/assistentes",
    permission: "assistentes",
  },
  {
    icon: <Icons.compains className="w-[19px] h-[19px]" />,
    title: "Campanhas",
    path: "/campanhas",
    permission: "campanhas",
  },
];

export const SettingsNavigationData: NavigationItem[] = [
  {
    icon: <Icons.settings className="w-[16px] h-[16px]" />,
    title: "Configurações",
    path: "/settings",
    permission: "configuracoes",
  },
  {
    icon: <Icons.logout className="w-[16px] h-[16px] ml-1" />,
    title: "Log out",
    path: "/login",
  },
];

export const AuthenticatedRoutes: RouteConfig[] = [
  { path: "/", element: <Dashboard />, permission: "dashboard", title: "Dashboard" },
  { path: "/contacts", element: <Contacts />, permission: "contatos", title: "Contatos" },
  { path: "/contacts/importar", element: <ImportarContatos />, permission: "contatos", title: "Importar Contatos" },
  { path: "/chat", element: <ConnectionGuard><Chat /></ConnectionGuard>, permission: "chat", title: "Chat" },
  { path: "/chat/:contactId", element: <ConnectionGuard><Chat /></ConnectionGuard>, permission: "chat", title: "Chat" },
  { path: "/crm", element: <Crm />, permission: "crm", title: "CRM" },
  { path: "/crm/:contactId", element: <AccessContacts />, permission: "crm", title: "Detalhes do Contato" },
  { path: "/agenda", element: <Agenda />, permission: "agenda", title: "Agenda" },
  { path: "/assistentes", element: <Assistentes />, permission: "assistentes", title: "Assistentes" },
  { path: "/assistentes/novo", element: <AssistenteNovo />, permission: "assistentes", title: "Novo Assistente" },
  { path: "/assistentes/editar/:id", element: <AssistenteEditar />, permission: "assistentes", title: "Editar Assistente" },
  { path: "/campanhas", element: <Campaigns />, permission: "campanhas", title: "Campanhas" },
  { path: "/settings", element: <Settings />, permission: "configuracoes", title: "Configurações" },
  { path: "/agency", element: <Agency />, permission: "configuracoes", title: "Agência" },
  { path: "/debug", element: <Debug />, title: "Debug" },
  { path: "/test-error", element: <TestError />, title: "Test Error" },
];
